import {Layout, Text} from '@di-nxt/components';
import React from 'react';

type Props = {
  title: string;
};

export const SectionHeader: React.FC<Props> = ({title}) => {
  return (
    <Layout padding="20" paddingBottom="40">
      <Text variant="inline_16_emphasis">{title}</Text>
    </Layout>
  );
};
